export default __webpack_public_path__ + "static/media/logo.0e88888e.svg";